import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import { useState, useEffect } from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { explanationAlertStyles } from './explanationAlertStyles';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  selectAllVestingInfo,
  selectVestingInfoLoading
} from '../../store/vestingInfo/vestingInfoSlice';
import { LoadingType } from '../../models/LoadingType';
import Link from '@mui/material/Link';

export const ExplanationAlert = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const isDark = theme.palette.mode === 'dark';
  const classes = explanationAlertStyles(theme, isDark);

  const allVestingInfo = useSelector(selectAllVestingInfo);
  const vestingInfoLoading = useSelector(selectVestingInfoLoading);
  const [open, setOpen] = useState(false);
  const contactEmail = `mailto:${t('vesting.contact_support_mail')}`;
  useEffect(() => {
    if (vestingInfoLoading !== LoadingType.Succeeded) {
      setOpen(false);
      return;
    }

    if (allVestingInfo?.length > 0) {
      const isBuyerUser = allVestingInfo.some((vestingInfo) => {
        return vestingInfo.canClaim;
      });
      setOpen(!isBuyerUser);
    }
  }, [allVestingInfo, vestingInfoLoading]);

  return (
    <Stack sx={{ width: '100%' }} spacing={2}>
      <Snackbar
        open={open}
        autoHideDuration={2000}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        message='Archived'
      >
        <Alert
          severity='info'
          action={
            <IconButton
              aria-label='close'
              color='inherit'
              size='small'
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon fontSize='inherit' />
            </IconButton>
          }
          sx={classes.icon}
        >
          <AlertTitle sx={classes.title}>{t('vesting.alert.title')}</AlertTitle>
          <Box sx={classes.textContainer}>
            <Typography component='div' variant='body2' sx={classes.mainText}>
              <Trans
                i18nKey={'vesting.alert.main_text'}
                components={[
                  <Link
                    variant='body2'
                    sx={classes.boldText}
                    href={contactEmail}
                    target='_blank'
                  />
                ]}
              />
            </Typography>
          </Box>
        </Alert>
      </Snackbar>
    </Stack>
  );
};
